import React from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

type BreadcrumbItem = {
  label: string;
  to?: string;
};

type Props = {
  items: BreadcrumbItem[];
};

const OrganizationBreadcrumb = ({ items }: Props) => {
  return (
    <BreadcrumbWrapper>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <Separator>
              <NavigateNextIcon sx={{ fontSize: 16 }} />
            </Separator>
          )}
          {item.to ? (
            <BreadcrumbLink to={item.to}>{item.label}</BreadcrumbLink>
          ) : (
            <BreadcrumbCurrent>{item.label}</BreadcrumbCurrent>
          )}
        </React.Fragment>
      ))}
    </BreadcrumbWrapper>
  );
};

export default OrganizationBreadcrumb;

const BreadcrumbWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  margin-bottom: 16px;
  font-size: 13px;
`;

const BreadcrumbLink = styled(Link)`
  color: rgba(0, 0, 0, 0.6);
  text-decoration: none;
  &:hover {
    color: rgba(0, 0, 0, 0.87);
    text-decoration: underline;
  }
`;

const BreadcrumbCurrent = styled.span`
  color: rgba(0, 0, 0, 0.87);
  font-weight: 500;
`;

const Separator = styled.span`
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.4);
`;

